export enum TasksType {
    MainTaskEntity,
    SubTasksEntity
}
